"use strict";
/*
Copyright 2018 - 2022 The Alephium Authors
This file is part of the alephium project.

The library is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

The library is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with the library. If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
utils_1.assertType;
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
(0, utils_1.assertType)();
utils_1.assertType;
(0, utils_1.assertType)();
